import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, DatePicker, Spin } from 'antd';
import { get, save, setPending } from '../redux/actions/ordenTrabajoActions';
import { get as getActividad } from '../redux/actions/actividadActions';
import { save as saveNumero } from '../redux/actions/configuracionActions';
import { getAllByParent as getActividadInversores } from '../redux/actions/actividadInversorActions';

import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import dayjs from 'dayjs';
import {
  ExclamationCircleOutlined,
  PlusOutlined,
  EditOutlined,
} from '@ant-design/icons';
import ProveedorEditor from './ProveedorEditor';
import { setPending as setPendingProveedor } from '../redux/actions/proveedorActions';
import LaborEditor from './LaborEditor';
import { setPending as setPendingLabor } from '../redux/actions/laborActions';
import { compareObject } from '../utils/funtions';
import { callStatus } from '../utils/constants';
import { Notificacion } from './Notificacion';

import {
  DraggableModal,
  DraggableModalProvider,
} from 'ant-design-draggable-modal';
const { confirm } = Modal;
const { Option } = Select;
const { TextArea } = Input;

const OrdenTrabajoEditor = ({
  dispatch,
  id,
  parentId,
  stateData,
  visible,
  onCancel,
  proveedor,
  labor,
  inversor,
  actividadInversor,
  ordenTrabajoEstado,
  configuracion,
  actividad,
}) => {
  const [form] = Form.useForm();

  const format = 'YYYY-MM-DD';
  const formatDisplay = 'DD/MM/YYYY';

  const [proveedorData, setProveedorData] = useState([]);
  const [showEditProveedor, setShowEditProveedor] = useState(false);
  const [proveedorIdEdit, setProveedorIdEdit] = useState(null);
  const [proveedorIdSelected, setProveedorIdSelected] = useState(null);

  const [showEditLabor, setShowEditLabor] = useState(false);
  const [laborIdEdit, setLaborIdEdit] = useState(null);
  const [laborIdSelected, setLaborIdSelected] = useState(null);

  const handleHideProveedorEditor = () => {
    setShowEditProveedor(false);
    setProveedorIdEdit(null);
    dispatch(setPendingProveedor());
  };

  const handleProveedorEdit = () => {
    setProveedorIdEdit(proveedorIdSelected);
    setShowEditProveedor(true);
  };

  const handleProveedorCreate = () => {
    setProveedorIdEdit(null);
    setShowEditProveedor(true);
  };

  const handleHideLaborEditor = () => {
    setShowEditLabor(false);
    setLaborIdEdit(null);
    dispatch(setPendingLabor());
  };

  const handleLaborEdit = () => {
    setLaborIdEdit(laborIdSelected);
    setShowEditLabor(true);
  };

  const handleLaborCreate = () => {
    setLaborIdEdit(null);
    setShowEditLabor(true);
  };

  useEffect(() => {
    if (
      proveedor.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditProveedor
    ) {
      const saved = proveedor.object.data;
      setResultSearchProveedor((prev) => {
        if (!prev.some((p) => p.id === saved.id)) return [...prev, saved];
        return prev.map((p) => (p.id === saved.id ? saved : p));
      });
      setProveedorData((prev) => {
        if (!prev.some((p) => p.id === saved.id)) return [...prev, saved];
        return prev.map((p) => (p.id === saved.id ? saved : p));
      });
      form.setFieldsValue({
        proveedor_id: saved.id,
        precio_superficie: saved.precio_superficie,
      });
      setProveedorIdSelected(saved.id);
    }
  }, [proveedor.object.status, showEditProveedor, proveedor.object.data, form]);

  useEffect(() => {
    if (
      labor.object.status === callStatus.OBJECT_SAVE_SUCCESS &&
      showEditLabor
    ) {
      const saved = labor.object.data;
      setResultSearchLabor((prev) => {
        if (!prev.some((p) => p.id === saved.id)) return [...prev, saved];
        return prev.map((p) => (p.id === saved.id ? saved : p));
      });
      form.setFieldsValue({ labor_id: saved.id });
      setLaborIdSelected(saved.id);
    }
  }, [labor.object.status, showEditLabor, labor.object.data, form]);

  useEffect(() => {
    if (id) {
      if (String(stateData.object.data?.id) !== String(id)) {
        dispatch(get(id));
      }
    } else {
      dispatch(setPending());
    }
    if (parentId) {
      dispatch(getActividadInversores(parentId));
      dispatch(getActividad(parentId));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (actividad?.object?.status === callStatus.OBJECT_SUCCESS && !id) {
      form.setFieldsValue({ superficie: actividad.object.data.superficie });
    }
    // eslint-disable-next-line
  }, [actividad?.object?.status, id, form]);

  useEffect(() => {
    setProveedorData(
      proveedor.list.data.filter(
        (item) => item.tipo_id === 2 || item.tipo_id === 3
      )
    );
    // eslint-disable-next-line
  }, [proveedor]);

  useEffect(() => {
    let data = cloneDeep(stateData.object.data);
    data['fecha'] = moment(moment(data.fecha));

    if (stateData.object.status === callStatus.OBJECT_SUCCESS) {
      data['fecha'] = moment(moment(data.fecha));

      form.setFieldsValue(data);
      setInitial(data);

      if (stateData.object.data.proveedor) {
        setResultSearchProveedor([data.proveedor]);
        setProveedorIdSelected(data.proveedor_id || null);
      }
      if (stateData.object.data.labor) {
        setResultSearchLabor([data.labor]);
        setLaborIdSelected(data.labor_id || null);
      }
    } else if (stateData.object.status === callStatus.OBJECT_PENDING) {
      form.resetFields();
      setInitial({});
      setResultSearchProveedor([]);
      setResultSearchLabor([]);
      setProveedorIdSelected(null);
      setLaborIdSelected(null);

      if (
        !id &&
        configuracion &&
        configuracion.list.status === callStatus.LIST_SUCCESS
      ) {
        let initData = {};
        const numeroItem = configuracion.list.data.find(
          (value) => value.nombre === 'orden_trabajo_num'
        );
        if (numeroItem) {
          const numero = parseInt(numeroItem.valor) + 1;
          initData['numero'] = numero.toString().padStart(8, '0');
        }
        form.setFieldsValue(initData);
      }
    } else if (stateData.object.status === callStatus.OBJECT_SAVE_SUCCESS) {
      Notificacion('El registro se guardó con éxito', 'success', onCancel);
    } else if (stateData.object.status === callStatus.OBJECT_FAILED) {
      Notificacion(stateData.object.error, 'error', () => {});
    }

    // eslint-disable-next-line
  }, [stateData.object]);

  const onCreate = (data) => {
    data.actividad_id = parentId;
    data.fecha = dayjs(new Date(data.fecha).toISOString()).format(format);

    if (
      (data.estado_id === 3 || data.estado_id === 4) &&
      (!data.importe || !data.inversor_id)
    ) {
      Notificacion(
        'Para Finalizar o Simular debe completar Importe e Inversor ',
        'error',
        () => {}
      );
    } else if (
      id &&
      data.estado_id === 3 &&
      stateData.object.data?.insumos?.length > 0
    ) {
      confirm({
        title:
          'Esta a punto de Finalizar un OT, los insumos utilizados también cambiarán a finalizados, desea continuar ?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          const insumosInvalidos = stateData.object.data.insumos.filter(
            (ins) => !ins.importe || !ins.inversor_id
          );

          if (insumosInvalidos.length > 0) {
            Notificacion(
              'No se puede finalizar. Uno o más insumos no poseen Importe o Inversor.',
              'error',
              () => {}
            );
          } else {
            dispatch(save(data)).then((response) => {
              if (!id) {
                dispatch(
                  saveNumero({ id: 1, valor: parseInt(data.numero, 10) })
                );
              }
            });
          }
        },
        onCancel() {},
      });
    } else {
      dispatch(save(data)).then((response) => {
        if (!id) {
          dispatch(saveNumero({ id: 1, valor: parseInt(data.numero, 10) }));
        }
      });
    }
  };

  const [initial, setInitial] = useState({});

  const handleOnCancel = () => {
    if (compareObject(initial, form.getFieldsValue())) {
      confirm({
        title: 'Posee cambios sin guardar, desea continuar?',
        icon: <ExclamationCircleOutlined />,
        okText: 'Si',
        cancelText: 'No',
        autoFocusButton: 'cancel',
        onOk() {
          onCancel();
        },
        onCancel() {},
      });
    } else {
      onCancel();
    }
  };
  const [resultSearchProveedor, setResultSearchProveedor] = useState([]);
  const [resultSearchLabor, setResultSearchLabor] = useState([]);

  const onSearchProveedor = (value) => {
    const result = proveedorData.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchProveedor(result);
  };

  const onSearchLabor = (value) => {
    const result = labor.list.data.filter((item) =>
      item.nombre.toLowerCase().includes(value.toLowerCase())
    );
    setResultSearchLabor(result);
  };

  const handleChangeProveedor = (value) => {
    const prov = proveedorData.find((item) => item.id === value);
    if (prov) {
      form.setFieldsValue({ precio_superficie: prov.precio_superficie });
    }
    setProveedorIdSelected(value);
  };

  const calcImporte = () => {
    const superficie = form.getFieldValue('superficie');
    const precio_superficie = form.getFieldValue('precio_superficie');
    const dolar = form.getFieldValue('dolar');

    if (superficie && precio_superficie && dolar) {
      const importe = (superficie * precio_superficie) / dolar;
      form.setFieldsValue({ importe: importe.toFixed(3) });
    }
  };

  return (
    <>
      <DraggableModalProvider>
        <DraggableModal
          mask
          initialWidth={700}
          initialHeight={700}
          maskClosable={false}
          visible={visible}
          title={
            stateData.object.data.id
              ? 'Editar Orden de Trabajo'
              : 'Nueva Orden de Trabajo'
          }
          okText="Guardar"
          cancelText="Salir"
          onCancel={handleOnCancel}
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                onCreate(values);
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
        >
          <Spin
            spinning={
              stateData.object.status === callStatus.OBJECT_IN_PROCESS ||
              !!(id && stateData.object.status === callStatus.OBJECT_PENDING)
            }
          >
            <Form form={form} layout="vertical" name="form_in_modal">
              <Row gutter={[8, 0]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="id" label="id" style={{ display: 'none' }}>
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[8, 0]}>
                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item
                    name="fecha"
                    label="Fecha"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <DatePicker
                      format={formatDisplay}
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item
                    name="numero"
                    label="Número"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input readOnly />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                  <Form.Item
                    name="estado_id"
                    label="Estado"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Select>
                      {ordenTrabajoEstado.list.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      name="proveedor_id"
                      label="Contratista"
                      rules={[
                        {
                          required: true,
                          message: 'Requerido',
                        },
                      ]}
                      style={{ flex: 1 }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={onSearchProveedor}
                        onChange={handleChangeProveedor}
                        notFoundContent={null}
                        allowClear
                      >
                        {resultSearchProveedor.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.nombre}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div>
                      {proveedorIdSelected ? (
                        <EditOutlined
                          onClick={handleProveedorEdit}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      ) : (
                        <PlusOutlined
                          onClick={handleProveedorCreate}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      )}
                    </div>
                  </div>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Form.Item
                      name="labor_id"
                      label="Labor"
                      rules={[
                        {
                          required: true,
                          message: 'Requerido',
                        },
                      ]}
                      style={{ flex: 1 }}
                    >
                      <Select
                        showSearch
                        optionFilterProp="children"
                        defaultActiveFirstOption={false}
                        showArrow={false}
                        filterOption={false}
                        onSearch={onSearchLabor}
                        onChange={(val) => setLaborIdSelected(val)}
                        notFoundContent={null}
                        allowClear
                      >
                        {resultSearchLabor.map((item, index) => (
                          <Option key={index} value={item.id}>
                            {item.nombre}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div>
                      {laborIdSelected ? (
                        <EditOutlined
                          onClick={handleLaborEdit}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      ) : (
                        <PlusOutlined
                          onClick={handleLaborCreate}
                          style={{ paddingLeft: '7px', cursor: 'pointer' }}
                        />
                      )}
                    </div>
                  </div>
                </Col>

                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="superficie"
                    label="Superficie"
                    rules={[
                      {
                        required: true,
                        message: 'Requerido',
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      addonBefore="ha"
                      onBlur={calcImporte}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item
                    name="precio_superficie"
                    label="Precio por Superficie"
                  >
                    <Input type="number" addonBefore="$" onBlur={calcImporte} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item name="dolar" label="Dolar">
                    <Input
                      type="number"
                      addonBefore="U$D"
                      onBlur={calcImporte}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <Form.Item name="importe" label="Importe">
                    <Input type="number" addonBefore="U$D" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="inversor_id" label="Aportante">
                    <Select allowClear>
                      {actividadInversor &&
                        actividadInversor.list.data.map((item) => (
                          <Select.Option key={item.id} value={item.inversor_id}>
                            {item.inversor?.nombre}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item name="observacion" label="Observación">
                    <TextArea />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </DraggableModal>
        {showEditProveedor ? (
          <ProveedorEditor
            id={proveedorIdEdit}
            onCancel={handleHideProveedorEditor}
            visible={true}
          />
        ) : (
          false
        )}
        {showEditLabor ? (
          <LaborEditor
            id={laborIdEdit}
            onCancel={handleHideLaborEditor}
            visible={true}
          />
        ) : (
          false
        )}
      </DraggableModalProvider>
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    ordenTrabajo,
    proveedor,
    labor,
    inversor,
    ordenTrabajoEstado,
    configuracion,
    actividadInversor,
    actividad,
  } = state;
  const stateData = ordenTrabajo;
  return {
    stateData,
    proveedor,
    labor,
    inversor,
    actividadInversor,
    ordenTrabajoEstado,
    configuracion,
    actividad,
  };
};
export default connect(mapStateToProps)(OrdenTrabajoEditor);
